import React, { useState, useEffect } from 'react';
import api from '../api';

export default function FrontendUsersSection({ token, setError }) {
  const [frontendUsers, setFrontendUsers] = useState(null);
  const [newUser, setNewUser] = useState({ name: '', email: '', password: '', role: 'user' });

  const fetch = async () => {
    try {
      const res = await api.get('/admin/frontend-users', {
        headers: { Authorization: `Bearer ${token}` },
      });
      setFrontendUsers(res.data.users);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to fetch frontend users');
    }
  };

  useEffect(() => {
    if (!token) return;
    fetch();
  }, [token]);

  if (!frontendUsers) return null;

  return (
    <div className="mb-6">
      <h3 className="text-xl font-semibold mb-4 text-indigo-600">Frontend Users</h3>
      <form
        onSubmit={async (e) => {
          e.preventDefault();
          try {
            await api.post(
              '/admin/frontend-users',
              newUser,
              { headers: { Authorization: `Bearer ${token}` } }
            );
            setNewUser({ name: '', email: '', password: '', role: 'user' });
            fetch();
          } catch (err) {
            setError(err.response?.data?.error || '');
          }
        }}
        className="mb-4 flex flex-wrap gap-2"
      >
        <input
          placeholder="name"
          value={newUser.name}
          onChange={(e) => setNewUser({ ...newUser, name: e.target.value })}
          className="border rounded px-2"
        />
        <input
          placeholder="email"
          value={newUser.email}
          onChange={(e) => setNewUser({ ...newUser, email: e.target.value })}
          className="border rounded px-2"
        />
        <input
          type="password"
          placeholder="password"
          value={newUser.password}
          onChange={(e) => setNewUser({ ...newUser, password: e.target.value })}
          className="border rounded px-2"
        />
        <select
          value={newUser.role}
          onChange={(e) => setNewUser({ ...newUser, role: e.target.value })}
          className="border rounded px-2"
        >
          <option value="user">user</option>
          <option value="admin">admin</option>
        </select>
        <button className="bg-blue-600 text-white px-3 rounded shadow hover:bg-blue-700 transition">Add</button>
      </form>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {frontendUsers.map((u) => (
          <div
            key={u.id}
            className="p-4 bg-white rounded-lg shadow hover:shadow-lg transition flex justify-between items-start"
          >
            <div>
              <div className="font-medium">{u.name} ({u.email})</div>
              <div className="text-sm text-gray-500">
                {u.mobile && `mobile: ${u.mobile}`} {u.google_id && `google:${u.google_id}`}
              </div>
              <div className="text-sm text-gray-500">role: {u.role}</div>
            </div>
            <button
              className="text-red-500 hover:text-red-700"
              onClick={async () => {
                await api.delete(`/admin/frontend-users/${u.id}`, {
                  headers: { Authorization: `Bearer ${token}` },
                });
                fetch();
              }}
            >
              Delete
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
